import { render, staticRenderFns } from "./PictureLibrary.vue?vue&type=template&id=6725dd25"
import script from "./PictureLibrary.vue?vue&type=script&lang=js"
export * from "./PictureLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports